import config from "../config.js";
import RequestManager from "./request.js";

export default class FSEWithInfo {
    
    static sendFSEToBackend(obj) {
        const url = config.urlBackEnd + 'FseLoad';
        const json = JSON.stringify(obj);
        console.log(json);
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: json
        })
            .then(response => {
                return response.json();
            })

            .then(data => {
                console.log(data); // Affichage pour déboguer
                return data// Traiter les données ici
            })
            .catch(error => alert("Erreur le problème : " + error));
    }

    static transmettreFse(obj) {
        const url = config.urlBackEnd + 'TransmettreFse';
        const json = JSON.stringify(obj);
        console.log(json);
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: json
        })
            .then(response => {
                //return response.json();
            })

            .then(data => {
                console.log(data); // Affichage pour déboguer
                return data// Traiter les données ici
            })
            .catch(error => alert("Erreur le problème : " + error));
    }

    static setCarteCPS(obj) {
        console.log("setCarteCPS(obj) avec obj = ", obj);
        RequestManager.post(config.urlBackEnd + 'SetCPS', obj);
    }
    static getCarteCPS() {
        return RequestManager.get(config.urlBackEnd + "GetCPS")
            .then(response => {
                return response
            })
            .catch(error => console.log("error in FSEWithInfo.getCarteCPS : ", error));
    }

    static setCarteVitale(obj) {
        return RequestManager.post(config.urlBackEnd + 'SetVitale', obj).then(response => { return response; });
    }

    static getCarteVitale(obj) {
        return RequestManager.post(config.urlBackEnd + 'GetVitale', obj).then(response => { return response; });
    }
}
